










































































































































































































import { Component, Prop, Watch, Model, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { randomId } from "@/utils";

@Component({
  components: {
    BPopover,
  },
})
export default class SelectPopover extends Vue {
  @Model("changed") readonly modelValue!: any;
  @Prop() readonly initValue!: any;
  @Prop(String) readonly selectType!: string;
  @Prop(String) readonly extTarget!: string;
  @Prop(String) readonly toggleType!: string;
  @Prop(String) readonly toggleLabel!: string;
  @Prop(String) readonly toggleLabelClass!: string;
  @Prop(String) readonly toggleLabelStyle!: string;
  @Prop(Boolean) readonly toggleHideSelected!: boolean;
  @Prop() readonly toggleClass!: any;
  @Prop() readonly toggleStyle!: any;
  @Prop(String) readonly buttonIcon!: string;
  @Prop(String) readonly saveButtonIcon!: string;
  @Prop(String) readonly saveButtonLabel!: string;
  @Prop(Boolean) readonly multiselect!: boolean;
  @Prop(Boolean) readonly returnItem!: boolean;
  @Prop(Array) readonly items!: Array<any>;
  @Prop(Array) readonly selectedItems!: Array<any>;
  @Prop(String) readonly title!: string;
  @Prop(String) readonly icon!: string;
  @Prop(String) readonly rightIcon!: string;
  @Prop(String) readonly text!: string;
  @Prop(String) readonly value!: string;
  @Prop(Boolean) readonly hideClear!: boolean;
  @Prop() readonly payload!: any;
  @Prop(Boolean) readonly disabled!: boolean;
  id = `select-popover-id-${randomId(6)}`;
  target = `select-popover-target-${randomId(6)}`;
  searchText = "";
  checkableItems: any[] = [];
  selected: any = null;
  show = false;
  @Watch("items")
  onItemsChanged() {
    if (this.multiselect) {
      this.checkableItems = JSON.parse(
        JSON.stringify(
          this.items.map((item) => {
            item.checked = false;
            return item;
          })
        )
      );
      if (this.selectedItems && this.selectedItems.length) {
        this.checkableItems.forEach((item) => {
          if (this.returnItem) {
            item.checked = this.selectedItems.find(
              (i) => i[this.value] === item[this.value]
            )
              ? true
              : false;
          } else {
            item.checked = this.selectedItems.includes(item[this.value]);
          }
        });
      }
    }
    this.selectModelItem();
    this.selectInitValue();
  }
  @Watch("modelValue")
  onModelChanged() {
    this.selectModelItem();
  }
  @Watch("initValue")
  onInitValueChanged() {
    this.selectInitValue();
  }
  get filteredItems() {
    const items = this.multiselect ? this.checkableItems : this.items;
    if (this.searchText) {
      return items.filter((item) => {
        return item[this.text]
          .toLowerCase()
          .includes(this.searchText.toLowerCase());
      });
    } else {
      return items;
    }
  }
  get checkedItems() {
    return this.checkableItems.filter((item) => item.checked);
  }
  get checkedItemNames() {
    return this.checkedItems.map((item) => item[this.text]).join(", ");
  }

  get isAllChecked(){
    return this.filteredItems.filter(f=> f.checked).length===this.filteredItems.length;
  }
  checkItems() {
    this.checkableItems.forEach((item) => {     
      //item.checked = this.filteredItems.includes(item);
       if(this.filteredItems.includes(item))
       item.checked = true;
    });
  }
  uncheckItems() {
    this.checkableItems.forEach((item) => {
      if(this.filteredItems.includes(item))
      item.checked = false;
    });
  }
  select(item) {
    this.selected = item;
    if (this.returnItem) {
      this.$emit("selected", item, this.payload);
      this.$emit("changed", item);
    } else {
      this.$emit("selected", item[this.value], this.payload);
      this.$emit("changed", item[this.value]);
    }
    this.close();
  }
  selectItems() {
    if (this.returnItem) {
      this.$emit("selected", this.checkedItems);
    } else {
      this.$emit(
        "selected",
        this.checkedItems.map((item) => item[this.value])
      );
    }
    this.close();
  }
  selectModelItem() {
    if (this.modelValue !== null && typeof this.modelValue !== "undefined") {
      this.selected = this.items.find((i) => i[this.value] == this.modelValue);
    }
  }
  selectInitValue() {
    if (this.initValue !== null && typeof this.initValue !== "undefined") {
      this.selected = this.items.find((i) => i[this.value] == this.initValue);
    }
  }
  clear() {
    if (this.multiselect) {
      this.checkableItems = [];
      this.$emit("selected", []);
      this.$emit("changed", []);
    } else {
      this.selected = null;
      this.$emit("selected", null);
      this.$emit("changed", null);
    }
    this.close();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    this.selectModelItem();
    this.selectInitValue();
  }
}
